<template>
  <mx-dialog class="init-dialog">
    <div class="info-wrap">
      <div class="info-block">
        <img class="user-icon" :src="file.avatar || file.headimgurl || DEFAULT_ICON_IMG" alt="" />
        <div class="user-name text-ellipsis">{{ getDisplayName(file) }}</div>
        <template v-if="file.teamFile && file.code === 403">
          <div class="main-tip">给你分享了一份团队文件</div>
          <div class="team sub-tip">仅“{{ teamName }}”团队成员可查看，请先登录</div>
        </template>
        <template v-else-if="file.status === 4">
          <div class="main-tip">邀请你一起加入编辑</div>
          <div class="sub-tip">登录后可对此文档进行编辑</div>
        </template>
        <template v-else>
          <div class="main-tip">给你分享了一份文档</div>
          <div class="sub-tip">登录后，此文档将保存至我的账号中</div>
        </template>
      </div>
      <div class="login-block">
        <el-button type="primary" class="login-btn" @click="handleLogin" v-tracker="'WEB_CLICK_WIDGET_LOGIN'"
          >登录</el-button
        >
        <div v-if="!file.teamFile" class="login-tip" @click="handleCancel" v-tracker="'WEB_CLICK_NOT_LOGIN'">
          暂不登录，仅查看文档
        </div>
      </div>
    </div>
  </mx-dialog>
</template>

<script>
import Vue from 'vue';
import { mapState } from 'vuex';
import { get } from 'lodash-es';
import LoginLogic from '@business/Common/LoginLogic/LoginLogic';
import DEFAULT_ICON_IMG from '@assets/images/dashboard/icon_avatar.png';
import { Common } from '@utils';

export default {
  name: 'InitDialog',
  components: {
    [LoginLogic.name]: LoginLogic
  },
  computed: {
    ...mapState({
      file: state => get(state.dialogInfo, 'dialogData.file', {}),
      user: state => get(state.dialogInfo, 'dialogData.user', {})
    }),
    teamName() {
      const teamName = this.file.teamName || '';
      return this.handleTextEllpsis(teamName, 26);
    }
  },
  data() {
    return {
      DEFAULT_ICON_IMG,
      getDisplayName: Common.getDisplayName
    };
  },
  mounted() {
    console.log(this.file);
  },
  methods: {
    // 以中文字符作为标准，超多最大长度限制，以省略号代替
    handleTextEllpsis(name, maxLen) {
      const len = name.length || 0;
      const resName = len > maxLen ? `${name.slice(0, maxLen)}...` : name;
      return resName;
    },
    handleLoginSuccess() {
      window.location.reload();
    },
    handleLogin() {
      Vue.MXDialog.hide(true);
    },
    handleCancel() {
      Vue.MXDialog.close();
    }
  }
};
</script>

<style lang="scss" scoped>
@import './InitDialog.scss';
</style>
